<template>
  <div class="online-user-page">
    <div class="filter-box" style="margin-bottom: 10px">
      <el-button
        type="primary"
        size="small"
        @click="loadList"
        icon="el-icon-refresh"
        >刷新</el-button
      >
      <span style="margin-left: 12px; color: #888; font-size: 12px"
        >说明：在线状态由 Redis 会话实时探测，下线时间取自登录/登出日志</span
      >
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :height="tableHeight"
    >
      <el-table-column
        prop="Account"
        label="登录账号"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column prop="UserName" label="姓名" min-width="100" />
      <el-table-column prop="LoginIp" label="登录IP" min-width="130" />
      <el-table-column label="登录方式" min-width="110">
        <template slot-scope="scope">{{
          clientTypeName(scope.row.ClientType)
        }}</template>
      </el-table-column>
      <el-table-column prop="LoginTime" label="登录时间" min-width="160" />
      <el-table-column prop="LastActiveTime" label="最后活跃" min-width="160" />
      <el-table-column prop="OnlineDuration" label="在线时长" min-width="100" />
      <el-table-column label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag
            :type="statusTag(scope.row.Status)"
            effect="dark"
            size="small"
            >{{ scope.row.StatusName }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="OfflineTime" label="下线时间" min-width="160" />
      <el-table-column label="操作" min-width="110" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            :disabled="scope.row.Status !== 1"
            @click="forceLogout(scope.row)"
            >强制下线</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      tableHeight: document.documentElement.clientHeight - 180,
    }
  },
  mounted() {
    var _this = this
    window.addEventListener('resize', function () {
      _this.tableHeight = document.documentElement.clientHeight - 180
    })
    this.loadList()
  },
  methods: {
    loadList() {
      var _this = this
      this.$ajax.query('omsapi/onlineUser/list', 'post', {}, function (data) {
        _this.tableData = data && data.Result ? data.Result : []
      })
    },
    clientTypeName(type) {
      if (type === 2) return 'SSO单点登录'
      return '客户端登录'
    },
    statusTag(status) {
      if (status === 1) return 'success'
      if (status === 3) return 'danger'
      if (status === 4) return 'warning'
      return 'info'
    },
    forceLogout(row) {
      var _this = this
      var name = row.UserName || row.Account || '该用户'
      this.$confirm(
        '确定强制下线【' + name + '】吗？该用户当前会话将立即失效。',
        '提示',
        { type: 'warning' }
      )
        .then(function () {
          var dto = {
            UserKey: row.UserKey,
            UserId: row.UserId,
            UserName: row.UserName,
            EnterpriseCode: row.EnterpriseCode,
          }
          _this.$ajax.send(
            'omsapi/onlineUser/forceLogout',
            'post',
            dto,
            function (data) {
              if (data && data.IsSuccess) {
                _this.$message.success('已强制下线')
                _this.loadList()
              } else {
                _this.$message.error((data && data.OperationDesc) || '操作失败')
              }
            }
          )
        })
        .catch(function () {})
    },
  },
}
</script>
<style scoped>
.online-user-page {
  padding: 10px;
}
</style>
